const LOCAL_STORAGE_WISHLIST_KEY = 'shopify_wishlist';
const LOCAL_STORAGE_RECENTLY_VIEWED_KEY = 'shopify_recently_viewed';

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? JSON.parse(wishlist) : [];
};

const setWishlist = (array) => {
  localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, JSON.stringify(array));
};

const updateWishlistCounter = () => {
  const counter = document.querySelector('.wishlist-counter');
  if (counter) {
    const count = getWishlist().length;
    counter.textContent = count;
    if (count > 0) {
      counter.classList.remove('hidden');
    } else {
      counter.classList.add('hidden');
    }
  }
};

const toggleWishlist = (productHandle) => {
  let wishlist = getWishlist();
  if (wishlist.includes(productHandle)) {
    wishlist = wishlist.filter(handle => handle !== productHandle);
  } else {
    wishlist.push(productHandle);
  }
  setWishlist(wishlist);
  updateWishlistCounter();
  updateWishlistButtons();
  renderWishlistPage();
};

const updateWishlistButtons = () => {
  const wishlist = getWishlist();
  document.querySelectorAll('[data-wishlist-button]').forEach((btn) => {
    const handle = btn.getAttribute('data-product-handle');
    if (wishlist.includes(handle)) {
      btn.classList.add('wishlist-active');
      btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="#000" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg> <span>Remove from Wishlist</span>`;
    } else {
      btn.classList.remove('wishlist-active');
      btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg> <span>Add to Wishlist</span>`;
    }
  });
};

const renderWishlistPage = () => {
  const container = document.querySelector('[data-wishlist-container]');
  if (!container) return;

  const wishlist = getWishlist();
  if (wishlist.length === 0) {
    container.innerHTML = '<p class="text-center">Your wishlist is empty. <a href="/collections/all">Continue Shopping</a></p>';
    return;
  }

  container.innerHTML = '<div class="loading-spinner">Loading...</div>';
  
  let queries = wishlist.map(handle => fetch(`/products/${handle}?view=card`).then(res => res.text()));
  
  Promise.all(queries).then(htmlArray => {
    container.innerHTML = `<ul class="grid product-grid grid--4-col-desktop grid--2-col-tablet-down">
      ${htmlArray.map(html => `<li class="grid__item">${html}</li>`).join('')}
    </ul>`;
  }).catch(err => {
    container.innerHTML = '<p class="text-center">Failed to load wishlist items.</p>';
  });
};

document.addEventListener('DOMContentLoaded', () => {
  updateWishlistCounter();
  updateWishlistButtons();
  renderWishlistPage();

  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-button]');
    if (btn) {
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      if(handle) toggleWishlist(handle);
    }
  });
});
